import React, { useEffect, useState } from 'react';
import '../MiZona/MiZona.css';
import { getSolicitudes } from '../../services/revisarAplazamientoService';
import { formatearFecha } from '../MiZona/estadosPartido';
import PartidoVs from './PartidoVs';

const fechaHora = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const hora = d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${formatearFecha(String(iso).slice(0, 10))} ${hora}`;
};

// Solo gestión: botón + modal con las últimas solicitudes de aplazamiento y quién las pidió.
export default function UltimosAplazamientos({ temporada }) {
  const [abierta, setAbierta] = useState(false);
  const [lista, setLista] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!abierta) return undefined;
    setLista(null);
    setError(null);
    getSolicitudes(temporada)
      .then((d) => setLista(
        [...d.solicitudes].sort((a, b) => String(b.creadaEn).localeCompare(String(a.creadaEn)) || b.id - a.id),
      ))
      .catch((err) => setError(err));
    const alPulsar = (e) => { if (e.key === 'Escape') setAbierta(false); };
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, [abierta, temporada]);

  return (
    <>
      <button type="button" className="btn btn-secondary ap-ultimos-boton" onClick={() => setAbierta(true)}>
        Últimos aplazamientos
      </button>
      {abierta && (
        <div className="mz-modal-fondo" onClick={() => setAbierta(false)}>
          <div className="mz-modal ap-ultimos-modal" role="dialog" aria-modal="true" aria-labelledby="ap-ultimos-titulo"
            onClick={(e) => e.stopPropagation()}>
            <h3 id="ap-ultimos-titulo">Últimos aplazamientos{lista && ` (${lista.length})`}</h3>
            <p className="mz-modal-partido">Todas las solicitudes de la temporada, de la más reciente a la más antigua, con quién las pidió.</p>
            <div className="ap-ultimos-cuerpo">
            {error && <p className="msg-error" role="alert">{error.message || 'No se pudieron cargar las solicitudes.'}</p>}
            {!error && !lista && <p>Cargando…</p>}
            {lista && lista.length === 0 && <p className="mz-vacio">Todavía no hay solicitudes.</p>}
            {lista && lista.length > 0 && (
              <ul className="ap-lista">
                {lista.map((s) => (
                  <li key={s.id} className="ap-ultimo">
                    <span className="ap-ultimo-quien">
                      <strong>{s.jugador}</strong>
                      <span className="ap-limite">{fechaHora(s.creadaEn)}</span>
                    </span>
                    <span>Jornada {s.jornada} · {s.modalidad} · <PartidoVs partido={s} /></span>
                    <span className="ap-ultimo-chips">
                      {s.admiteWo && <span className="chip chip-warning">Admite WO</span>}
                      {s.tieneJustificante && <span className="chip chip-muted">Justificante</span>}
                      {s.revisadaEn ? <span className="chip chip-success">Revisada</span> : <span className="chip chip-muted">Pendiente</span>}
                    </span>
                  </li>
                ))}
              </ul>
            )}
            </div>
            <div className="mz-modal-acciones">
              <button type="button" className="btn btn-primary" onClick={() => setAbierta(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
